import { SettingValueType } from "@swagger/typescript-fetch-goflyer";

export const TYPE_COLORS: Record<string, string> = {
  boolean: "#10b981",
  number: "#3b82f6",
  json: "#8b5cf6",
  string: "#6b7280",
};

export const getTypeColor = (type: SettingValueType) =>
  TYPE_COLORS[type] ?? "#6b7280";

export const getDisplayValue = (
  value: unknown,
  valueType: SettingValueType,
): string => {
  if (value === undefined || value === null) return "";
  if (valueType === SettingValueType.Json) {
    try {
      return JSON.stringify(value, null, 2);
    } catch {
      return String(value);
    }
  }
  return String(value);
};

export const parseValue = (
  editValue: string,
  valueType: SettingValueType | "",
): unknown => {
  switch (valueType) {
    case SettingValueType.Boolean:
      return editValue === "true";
    case SettingValueType.Number:
      return editValue === "" ? undefined : Number(editValue);
    case SettingValueType.Json:
      try {
        return JSON.parse(editValue);
      } catch {
        return editValue;
      }
    default:
      return editValue;
  }
};

export const formatSettingKey = (key: string) =>
  key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

export const makeSettingKey = (category: string, settingKey: string) =>
  `${category}:${settingKey}`;

export const formatDefaultValue = (value: any, type: SettingValueType): string => {
  if (value === undefined || value === null) return "—";
  if (type === SettingValueType.Json) {
    try {
      return JSON.stringify(value);
    } catch {
      return String(value);
    }
  }
  return String(value);
};
